if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_pages_test_index_tsx":1,"src_pages_test1_index_tsx":1,"src_components_Dropdown_index_tsx-src_pages_Dashboard_index_tsx-src_assets_earth_png":1,"src_pages_Dashboard_pages_IogIn_index_tsx-src_assets_earth_png":1,"src_pages_Dashboard_pages_Register_index_tsx-src_assets_earth_png":1,"src_pages_NotFound_index_tsx-src_assets_404-warning_png-src_assets_404_png-src_assets_earth_png":1,"src_pages_SystemError_index_tsx-src_assets_401-warning_png-src_assets_401_png-src_assets_500--16061f":1,"src_pages_Terminal_index_tsx-node_modules_xterm_css_xterm_css":1,"src_components_BreathingBall_index_tsx-src_components_ui_Animation_ScrollintersectionObserver-426696":1,"src_components_WatermarkNotice_index_tsx-src_constants_aiToolEnum_tsx-src_hook_downloadImgVid-f9cb27":1,"src_pages_Dashboard_pages_AiTool_Video_index_tsx-src_components_AiEditor_index_scss-src_compo-7b69b5":1,"src_pages_Dashboard_pages_AiTool_Video_Details_index_tsx-src_components_AiEditor_index_scss-s-44b472":1,"src_pages_Dashboard_pages_AiTool_Img_index_tsx-src_components_AiEditor_index_scss-src_compone-802dbf":1,"src_pages_Dashboard_pages_AiTool_Img_Details_index_tsx-src_components_AiEditor_index_scss-src-1e53f4":1,"src_hook_subscription_index_tsx-src_pages_Dashboard_pages_Subscription_components_Segmented_i-9ae250":1,"src_components_Tabs_index_tsx-src_pages_Dashboard_pages_Asset_components_ImgVideoCard_index_t-41feb5":1,"src_components_AiEditor_index_scss-src_components_Editor_index_scss-src_components_EditorList-6cc651":1,"src_components_LanguageSwitcher_index_module_scss-src_pages_Dashboard_pages_UserSettings_comp-2e2358":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded